// Porcentaje de comisión del promotor (lo fija solo el admin). El backend acepta
// un número mayor que 0 y hasta 100 con máximo 2 decimales (`commission_invalid`).
const FORMAT = /^\d{1,3}(\.\d{1,2})?$/;

// Texto del campo -> { value: número } o { error: mensaje }. Acepta coma decimal.
export const parseCommissionPercent = (text) => {
  const clean = String(text == null ? '' : text).trim().replace(',', '.');
  if (!clean) return { error: 'Escribe el porcentaje de comisión.' };
  if (!FORMAT.test(clean)) {
    return { error: 'El porcentaje debe ser un número con máximo 2 decimales (por ejemplo 10 o 12.5).' };
  }
  const value = Number(clean);
  if (!(value > 0) || value > 100) {
    return { error: 'El porcentaje debe ser mayor que 0 y hasta 100.' };
  }
  return { value };
};

// 12.5 -> "12.5 %", 10 -> "10 %"
export const formatPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return `${Number.isInteger(n) ? n : n.toFixed(2).replace(/0+$/, '')} %`;
};
